import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_METRICS_API } from "./apiRoutes";
interface UseGetDistributionMetricByRuleIdProps {
  ruleId: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDistributionMetricByRuleId = async (ruleId: string, communityId: string) =>
  await axiosAuth.get(`${DISTRIBUTION_METRICS_API(communityId)}/rule/${ruleId}`);

const useGetDistributionMetricByRuleId = ({
  queryParams,
  communityId,
  ruleId,
}: UseGetDistributionMetricByRuleIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["distribution-metric", ruleId],
    queryFn: () => getDistributionMetricByRuleId(ruleId, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!ruleId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetDistributionMetricByRuleId;
